import { Grid } from '@material-ui/core'
import React, { useEffect } from 'react'
import SwitchForm from '../../../components/Forms/SwitchForm'
import LineInputForm from '../../../components/Forms/LineInputForm'
import LineSelectForm from '../../../components/Forms/LineSelectForm'
import SimpleModal from '../../../components/Modals/SimpleModal'
import RoundedButton from '../../../components/Actions/RoundedButton'

const AddApplicationModal = ({ open, form, onChange, onSubmit, onClose, content }) => {

    return (
        <SimpleModal maxWidth='sm' open={open} onClose={onClose}>
            <Grid container alignItems='center' spacing={4}>
                <Grid item xs={12}>
                    <LineSelectForm data={form.artist_id} onChange={onChange} />
                </Grid>
                <Grid item xs></Grid>
                <Grid item>
                    <RoundedButton size='small' onClick={() => onSubmit('application')}>
                        {content.add_button}
                    </RoundedButton>
                </Grid>
            </Grid>
        </SimpleModal>
    )
}

export default AddApplicationModal